<template>
    <div>
        <van-search placeholder="请输入搜索关键词" v-model="value" style="width: 100%;" @input="search"/>

        <div v-if="value" style="width: 100%;" @click="value = ''">
            <div v-for="(item,index) in searchList" :key="index" @click="gotoArticleDetail(item)" style="background-color: white; padding: 10px; color: #111111; margin-top: 1px; font-size: 14px;">
                {{item.newsTitle}}
            </div>
        </div>
        <div v-else class="content">
            <div class="line">
                <div class="title">精选内容</div>
                <div style="padding: 0 20px">
                    <van-swipe :autoplay="4000" indicator-color="white" style="width: 100%; height: 160px; border-radius: 4px;">
                        <van-swipe-item v-for="(item,index) in images" :key="index">
                            <van-image :src="item.imageUrl" width="100%" height="100%"/>
                        </van-swipe-item>
                    </van-swipe>
                    <div style="width: 100%; display: flex; align-items: center; margin: 15px 0;">
                        <div style="width: 40px;margin-right: 10px; font-style: italic; font-weight: bold; color: #1C7CF8;">阅读说明</div>
                        <van-swipe :autoplay="5000" :duration="600" vertical :show-indicators="false"
                                   style="height: 40px; flex:1;">
                            <van-swipe-item v-for="item in hots" :key="item.newId" @click="gotoArticleDetail(item)">
                                <div style="display: flex; align-items: center; justify-content: space-between;">
                                    <div style="font-size: 14px; display: flex; flex-direction: column; align-items: start; flex: 1;">
                                        <span :style="'color: #4E4E4E; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:'+ width+'px;'">{{item.newsTitle}}</span>
                                        <span :style="'margin-top: 2px; color: #999999; font-size: 12px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:'+ width +'px;'">{{item.abstracts}}</span>
                                    </div>
                                    <van-button type="info" round
                                                style="background-color: #1C7CF8; font-size: 14px; height: 28px; line-height: 28px;"
                                                @click="gotoArticleDetail(item)">立即查看
                                    </van-button>
                                </div>
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>
            </div>
            <div class="line">
                <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                          @change="getAritcleList()">
                    <van-tab v-for="item in list" :key="item.type" :title="item.title">
                        <van-list v-model="item.loading" :finished="item.finished" finished-text="没有更多了" @load="getAritcleList()">
                            <div v-for="(subItem,index) in item.list" :key="index"
                                 style="display: flex; justify-content: space-between; border-bottom: 1px #EFEFEF solid; padding: 10px 0;"
                                 @click="gotoArticleDetail(subItem)">
                                <div style="flex: 1; margin-left: 20px; display: flex; flex-direction: column; align-items: start;">
                                    <div style="color: #333333; font: 14px bold;">{{subItem.newsTitle}}</div>
                                    <div style="color: #999999; font-size: 12px; margin-top: 6px;">
                                        {{subItem.newsDate|dateFormat('YYYY年M月D日')}}
                                    </div>
                                </div>
                                <van-image :src="subItem.newsImage" radius="6px" width="92px" height="56"
                                           style="margin: 0 20px 0 15px;"/>
                            </div>
                        </van-list>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Swipe, SwipeItem, Tab, Tabs, List, Cell, Icon, Image, Search} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Swipe).use(SwipeItem).use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image).use(Search);

    export default {
        name: 'Study',
        components: {},
        data() {
            return {
                value: '',
                width: window.outerWidth - 190,
                type: Cookies.get('type'),
                active: 0,
                current: 0,
                images: [],
                hots: [],
                pageSize: 10,
                list: [
                    {title: '推荐', type: 1, page: 0, finished: false, loading: false, list: []},
                    {title: '短期险', type: 2, page:0, finished: false, loading: false, list: []},
                    {title: '长期险', type: 3, page:0, finished: false, loading: false, list: []},
                    {title: '咨询', type: 4, page:0, finished: false, loading: false, list: []},
                    {title: '理赔', type: 5, page:0, finished: false, loading: false, list: []},
                    {title: '阅读说明', type: 6, page:0, finished: false, loading: false, list: []},
                ],
                searchList: [],
            }
        },
        created() {
            this.getBannerImage()
            this.getHotArticle()
        },
        methods: {
            role() {
                return this.$store.state.user.role ? this.$store.state.user.role : '0'
            },
            gotoArticleDetail(item) {
                if (item.newsUrl.length > 0) {
                    window.location.href = item.newsUrl
                } else {
                    // this.$router.push({path: '/articleDetail', query: {newsId: item.newsId}})
                    window.location.href = `${process.env.VUE_APP_SHARE_URL}/articleDetail?newsId=${item.newsId}`
                }
            },
            getBannerImage() {
                this.$axios.get("/image/shuffling", {params: {imageType: '5', imageBelong: this.type}}).then(res => {
                    this.images = res.data;
                });
            },
            getHotArticle() {
                this.$axios.get("/article/list", {params: {type: '5', category: '6', newsBelong: this.type}}).then(res => {
                    this.hots = res.data.rows;
                });
            },
            getAritcleList() {
                const item = this.list[this.active]
                if (item.finished) {
                    return
                }
                item.page++;
                item.loading = true;
                this.$axios.get("/article/list", {params: {type: '5',page: item.page, pageSize: this.pageSize, category: item.type, newsBelong: this.type}}).then(res => {
                    item.loading = false;
                    let data = res.data.rows;
                    item.list = item.list.concat(data);
                    if(data.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    item.loading = false
                })
            },
            search(text){
                this.$axios.get("/article/fuzzyFind", {params: {newsTitle: text}}).then(res => {
                    this.searchList = res.data;
                });
            }
        }
    }
</script>

<style>
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
    }

    .line {
        border-top: #F3F3F3 10px solid;
        width: 100%;
    }

    .title {
        align-self: start;
        margin: 10px 0 10px 23px;
        text-align: start;
        font-size: 14px;
        font-weight: bolder;
    }

    .title::before {
        background-color: #1C7CF8;
        content: '';
        width: 3px;
        height: 14px;
        position: relative;
        right: 3px;
        top: 2px;
        display: inline-block;
    }
</style>
